import { UATConstants } from 'src/Common/Models/UATConstants';
import { ITenantUIConfig, TenantProvider } from 'src/tenantConfig/interface/index.ts';
import { ROBFilterConfig } from './filters/ROBFilterConfig';
import {
  filterableAndSelectableColumnsROB,
  fyDropdownValuesROB,
  meetingMonthDropdownValuesROB,
  meetingSubTypeDropdownValuesROB,
  meetingTypeDropdownValuesROB,
  newViewDefaultColumnOptionsListArtemisROB,
  solutionAreaDropdownValuesROB,
  stateDropdownValuesROB,
  subStateDropdownValuesROB,
} from 'src/Common/manageViews/utils/ManageViewConstants';

export const ROBTenantConfig: Partial<ITenantUIConfig> = {
  nodeName: [UATConstants.PlaceholdersAndTitles.MCAPSLeaderRoB],
  provider: TenantProvider.ARTEMIS,
  TenantExperience: true,
  FeatureConfig: {
    SensitiveInfoValidation: false,
    SensativeInfoErrorCount: false,
    FieldConfig: ROBFilterConfig,
    AttachmentConfigurations: [],
    Navigation: {
      GlobalSearch: true,
      Copilot: true,
      Analytics: false,
      RequestAccess: true,
      Settings: true,
      Notifications: true,
      Help: true,
    },
    Hub: {
      Filter: true,
      FilterConfig: ROBFilterConfig,
      AreaPath: [],
      Title: UATConstants.TenantTitles.ROB,
      ADOTitle: UATConstants.TenantADOText.ROB,
      Create: [
        {
          Text: UATConstants.CreateActionMenuTitle.CreateROBRequest,
          Key: UATConstants.CreateActionMenuKey.CreateROBRequest,
          NodeName: '',
        },
      ],
      BulkUpload: true,
      DownloadTemplate: true,
      DownloadTemplateConfig: {
        tenantToolName: 'rob',
        title: UATConstants.PlaceholdersAndTitles.MCAPSLeaderRoB,
        excelColumnSequence: {
          'Title': 1,
          'Assigned Team': 2,
          'Requestors': 3,
          'Requested Date': 4,
          'Solution Area': 5,
          'Segment(s)': 6,
          'Region(s)': 7,
          'Areas/SME&C OU': 8,
          'Sub-region/SME&C SU': 9,
          'Meeting Fiscal Year': 10,
          'Meeting Quarter': 11,
          'Meeting Month': 12,
          'MCAPS Meeting Types': 13,
          'MCAPS Meeting Sub-types': 14,
          'Action Owner Group': 15,
          'Action Owner': 16,
          'Triage Owner(s)': 17,
          'Contributors': 18,
          'Description': 19,
          'Business Impact': 20,
          'Next steps/Asks': 21,
          'Action Category': 22,
          // 'Revenue Impact (USD)': 21,
          'Impact Type': 23,
          'Cost Savings ($)': 24,
          'Number of Customers Impacted': 25,
          'Incremental Revenue ($)': 26,
          'Impact Value (Other)': 27,
          'Estimated Completion Date': 28,
          'Status Update': 29,
        },
      },
      Download: true,
      Email: true,
      LocalSearch: true,
      ColumnOptions: false,
      ColumnOptionsConfig: [],
      SplitMode: true,
      BulkEdit: false,
      BulkEditConfig: [],
      CreateRAID: false,
      SelectableColumns: filterableAndSelectableColumnsROB,
      DropdownValues: {
        [UATConstants.ArtemisFieldPaths.MeetingMonth]: meetingMonthDropdownValuesROB,
      },
    },
    ManageAction: {
      NewExperience: true,
      MandateFormPickers: [
         {
          formFieldName: 'assignedto',
          formFieldLabel: UATConstants.PlaceholdersAndTitles.ActionOwner,
          apiFieldName: 'assignedto',
        },
        {
          formFieldName: 'requestor',
          formFieldLabel: UATConstants.PlaceholdersAndTitles.Requestor,
          apiFieldName: 'requestorsinfo',
        },
        {
          formFieldName: 'triageOwner',
          formFieldLabel: UATConstants.PlaceholdersAndTitles.TriageOwner,
          apiFieldName: 'triageOwnersinfo',
        },
        {
          formFieldName: 'accountableexec',
          formFieldLabel: UATConstants.PlaceholdersAndTitles.AccountableExec,
          apiFieldName: 'accountableexec',
        },
        {
          formFieldName: 'contributors',
          formFieldLabel: UATConstants.PlaceholdersAndTitles.Contributors,
          apiFieldName: 'contributorsinfo',
        },
      ],
      Header: {
        Tags: true,
        Actions: {
          Follow: true,
          Email: true,
          CopyLink: true,
        },
      },
      Tabs: {
        TechnicalFeedback: false,
        RelatedItems: {
          showRelatedTab: true,
          showTFTCreated: false,
        },
        Attachments: true,
        History: true,
      },
      Panes: {
        CopilotInsights: {
          CustomerInsights: false,
          DiscussionInsights: false,
        },
        StatusUpdate: true,
        ClosureStatement: true,
        Discussion: true,
        Tasks: false,
        EmailConversation: false,
      },
    },
    ManageView: {
      showAddViewButton: true,
      showAddFolderButton: true,
      isArtemisIntegrationEnabled: true,
      showCommandBar: true,
      showPreviewFeatureMessageBar: false,
      showSelectFields: false,
      defaultViewId: 'b3f1a8e4-0123-4567-89bc-bcde45678901',
      systemViewsFolderId: 'a14f28d4-3008-46c5-a23a-358ffdebd76b',
      sharedViewsFolderId: 'a462728b-8393-4e4b-b836-10959495d957',
      defaultColumns: newViewDefaultColumnOptionsListArtemisROB,
      filterableColumns: filterableAndSelectableColumnsROB,
      selectableColumns: filterableAndSelectableColumnsROB,
      dropdownValues: {
        [UATConstants.ArtemisFieldPaths.MeetingType]: meetingTypeDropdownValuesROB,
        [UATConstants.ArtemisFieldPaths.MeetingSubType]: meetingSubTypeDropdownValuesROB,
        [UATConstants.ArtemisFieldPaths.MeetingFiscalYear]: fyDropdownValuesROB,
        [UATConstants.ArtemisFieldPaths.MeetingMonth]: meetingMonthDropdownValuesROB,
      },
    },
  },
};
